import { useTranslation } from '@exam-room/translations';
import * as Sentry from '@sentry/react';
import { useState } from 'react';

import { Button, Modal } from '../base';
import LoadingSpinner from '../loading-spinner';

interface FetchExamErrorModalProps {
  open: boolean;
  onRetry: () => Promise<void>;
}

export default function FetchExamErrorModal({ open, onRetry }: FetchExamErrorModalProps) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleRetry = async () => {
    setIsLoading(true);
    try {
      await onRetry();
    } catch (err) {
      // Error is handled by the parent component
      // Catching here prevents unhandled promise rejection
      Sentry.captureException(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal open={open} className='max-w-xl'>
      <div className='flex flex-col gap-4'>
        <h3 className='mb-6'>{t('fetchExamErrorModal.title')}</h3>
        <p className='text-text-secondary whitespace-pre-line'>
          {t('fetchExamErrorModal.description')}
        </p>
        <div className='flex justify-end'>
          <Button onClick={handleRetry} disabled={isLoading} className='w-[120px]'>
            {isLoading ? <LoadingSpinner /> : t('retry')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
